"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationError = exports["default"] = void 0;

var validationError = function validationError(meta, validateOnMount) {
  if (validateOnMount) {
    return meta.error || meta.submitError;
  }

  return meta.touched && (meta.error || meta.submitError);
};

exports.validationError = validationError;
var _default = validationError;
exports["default"] = _default;